export default {
      id: "burger-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/icons.ece5aa3c.svg#burger",
      toString: function () {
        return this.url;
      }
    }